import * as Yup from 'yup';
import { isValidCpf } from '../utils/isValidCpf';
import { isValidCnpj } from '../utils/isValidCnpj';

// CPF/CNPJ validados pelos utils compartilhados (utils/isValidCpf,
// utils/isValidCnpj) — também usados em PaymentMethodsForm. Antes havia
// uma implementação duplicada aqui (loop antigo, mutava o parâmetro);
// consolidado numa única fonte.

export const financingDataRules: any = {
    equipmentValue: Yup.string()
        .required('Campo obrigatório')
        .test(
            'invalid',
            'O valor deve ser maior que 0',
            (value) =>
                value.replace('R', '').replace('$', '').replace(',', '') > 0,
        ),
    inputValue: Yup.string()
        .required('Campo obrigatório')
        .test(
            'invalid',
            'O valor deve ser maior que 0',
            (value) =>
                value.replace('R', '').replace('$', '').replace(',', '') > 0,
        ),
    financedValue: Yup.string().required('Campo obrigatório'),
    waitingPeriod: Yup.string().required('Campo obrigatório'),
    installments: Yup.string().required('Campo obrigatório'),
    installmentsValue: Yup.string().required('Campo obrigatório'),
};

export const juridicPersonRules: any = {
    entityCompanyName: Yup.string().required('Campo obrigatório'),
    entityFancyName: Yup.string().required('Campo obrigatório'),
    entityCnpj: Yup.string()
        .required('Campo obrigatório')
        .test('invalid', 'CNPJ inválido', (value) => isValidCnpj((value || '').replace(/\D/g, ''))),
    entityCapitalStock: Yup.string()
        .required('Campo obrigatório')
        .test(
            'invalid',
            'O valor deve ser maior que 0',
            (value) =>
                value.replace('R', '').replace('$', '').replace(',', '') > 0,
        ),
    entityLastYearRevenue: Yup.string()
        .required('Campo obrigatório')
        .test(
            'invalid',
            'O valor deve ser maior que 0',
            (value) =>
                value.replace('R', '').replace('$', '').replace(',', '') > 0,
        ),
    entityUptime: Yup.string().required('Campo obrigatório'),
    entityMainActivity: Yup.string().required('Campo obrigatório'),
    entityEmail: Yup.string().required('Campo obrigatório'),
    entityPhone: Yup.string().required('Campo obrigatório'),
    entityCellphone: Yup.string().required('Campo obrigatório'),
    entityAddress: Yup.string().required('Campo obrigatório'),
    entityNeighborhood: Yup.string().required('Campo obrigatório'),
    entityCityState: Yup.string().required('Campo obrigatório'),
    entityOwnProperty: Yup.string().required('Campo obrigatório'),
    entityAddressCep: Yup.string().required('Campo obrigatório'),
};

export const representativeRules: any = {
    personName: Yup.string().required('Campo obrigatório'),
    personCpf: Yup.string()
        .required('Campo obrigatório')
        .test('invalid', 'CPF inválido', (value) => isValidCpf((value || '').replace(/\D/g, ''))),
    personRg: Yup.string().required('Campo obrigatório'),
    personRgIssuer: Yup.string().required('Campo obrigatório'),
    personBirthdate: Yup.date().required('Campo obrigatório').nullable(),
    personSex: Yup.string().required('Campo obrigatório'),
    personCivilStatus: Yup.string().required('Campo obrigatório'),
    personBirthStateCity: Yup.string().required('Campo obrigatório'),
    personFatherName: Yup.string().required('Campo obrigatório'),
    personMotherName: Yup.string().required('Campo obrigatório'),
    personSchooling: Yup.string().required('Campo obrigatório'),
    personPatrimony: Yup.string().required('Campo obrigatório'),
    personMontlyIncome: Yup.string().required('Campo obrigatório'),
    personPhone: Yup.string().required('Campo obrigatório'),
    personCellphone: Yup.string().required('Campo obrigatório'),
    personProfessionNature: Yup.string().required('Campo obrigatório'),
    personProfession: Yup.string().required('Campo obrigatório'),
    personCompanyName: Yup.string().required('Campo obrigatório'),
    personEmail: Yup.string()
        .required('Campo obrigatório')
        .email('E-mail inválido'),
    personCompanyCnpj: Yup.string()
        .required('Campo obrigatório')
        .test('invalid', 'CNPJ inválido', (value) => isValidCnpj((value || '').replace(/\D/g, ''))),
};

export const financingRules = {
    ...financingDataRules,
    ...juridicPersonRules,
    ...representativeRules,
};

export default financingRules;
